import {Component, OnInit} from '@angular/core';
import { ConfirmationPreloaderService } from '../../services/confirmation-preloader.service';

@Component({
    selector: 'app-confirmation-preloader',
    templateUrl: './confirmation-preloader.component.html',
    styleUrls: ['./confirmation-preloader.component.css'],
    standalone: false
})
export class ConfirmationPreloaderComponent implements OnInit {
    public title = 'Activando los servicios';
    public description = 'Manténgase a la espera, este proceso puede durar varios segundos';
    public progress = 0;
    public httpError: false;
    private orderId: any;
    private order: any;
    private initialTime = 0;
    private firstSection = 0.75;
    private secondSection = 0.25;
    private firstTimeLimit = 30000;
    private secondTimeLimit = 60000;
    private timeBetweenRequests = 2000;

    constructor(private confirmationPreloaderService: ConfirmationPreloaderService) {
    }

    ngOnInit(): void {
        this.confirmationPreloaderService.getOrderId().subscribe((data: any) => {
            if (data != null) {
                this.orderId = data;
                this.initialTime = new Date().getTime();
                this.getOrder();
            }
        });

        this.confirmationPreloaderService.getHttpError().subscribe((data: any) => {
            if (data != null) {
                this.httpError = data;
            }
        });
    }

    getOrder() {
        if (this.initialTime === 0) {
            this.initialTime = new Date().getTime();
        }

        this.confirmationPreloaderService.getOrder(this.orderId).subscribe((data: any) => {
            this.order = data.msg;
            const now = new Date().getTime();
            const timeDifference = now - this.initialTime;

            if (timeDifference <= this.firstTimeLimit) {
                this.progress = (timeDifference * 100 / this.firstTimeLimit) * this.firstSection;
            } else if (timeDifference <= this.secondTimeLimit) {
                this.progress = 75 + ((timeDifference * 100 / this.secondTimeLimit) * this.secondSection);
            } else {
                this.progress = 100;
                this.confirmationPreloaderService.setPreloadingComplete(true);
                return;
            }

            console.log('Progress', this.progress);
            console.log('Order Status', this.order.status);
            console.log('Time progress', timeDifference);

            this.checkStatus();
        });
    }

    checkStatus() {
        if (this.order != null && this.order.exit_progress_bar) {
            this.progress = 100;
            this.confirmationPreloaderService.setPreloadingComplete(true);
        } else if (!this.httpError) {
            console.log('Se volverá a consultar el status en ' + this.timeBetweenRequests + ' milisegundos');
            setTimeout(() => this.getOrder(), this.timeBetweenRequests);
        } else {
            this.progress = 0;
            this.initialTime = 0;
            console.error('Error HTTP');
        }
    }
}
